import { z } from 'zod';

import { PaymentId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils';
import { BaseLoanEvent } from './BaseLoanEvent';

export const ReallocatePaymentsEvent = BaseLoanEvent.extend({
  type: z.literal('reallocatePayments'),
  paymentIds: z.array(zodBrandedUuid<PaymentId>()),
});
export type ReallocatePaymentsEvent = z.infer<typeof ReallocatePaymentsEvent>;
